import { render, staticRenderFns } from "./PhysicalExamsPerPrenatalConsultation.vue?vue&type=template&id=6648968a&scoped=true"
import script from "./PhysicalExamsPerPrenatalConsultation.vue?vue&type=script&lang=js"
export * from "./PhysicalExamsPerPrenatalConsultation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6648968a",
  null
  
)

export default component.exports